import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

import Link from './link'
import Icon from './icon'
import classes from '../styles/footer.module.sass'

export default () => (
    <StaticQuery
        query={query}
        render={({ site }) => {
            const {
                footer,
                email,
                twitter,
                github,
                youtube,
                company,
                companyUrl,
                imprintUrl,
            } = site.siteMetadata
            return (
                <footer className={classes.root}>
                    {footer.map(({ label, items = [] }, i) => (
                        <ul key={i} className={classes.list}>
                            <li>
                                <h3 className={classes.label}>{label}</h3>
                            </li>
                            {items.map(({ text, url, blank }, j) => (
                                <li key={j}>
                                    <Link to={url} hidden target={blank ? '_blank' : null}>
                                        {text}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    ))}
                    <ul className={classes.meta}>
                        <li>
                            <span style={{ fontFamily: 'sans-serif' }}>&copy;</span> 2017-
                            {new Date().getFullYear()}{' '}
                            <Link to={companyUrl} hidden>
                                {company}
                            </Link>
                        </li>
                        <li>
                            <Link to={imprintUrl} hidden>
                                Legal & Imprint
                            </Link>
                        </li>
                        <li>
                            <a href={`mailto:${email}`}>{email}</a>
                        </li>
                        <li>
                            <Link to={`https://twitter.com/${twitter}`} hidden aria-label="Twitter">
                                <Icon name="twitter" />
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`https://youtube.com/c/${youtube}`}
                                hidden
                                aria-label="YouTube"
                            >
                                <Icon name="youtube" />
                            </Link>
                        </li>
                        <li>
                            <Link to={`https://github.com/${github}`} hidden aria-label="GitHub">
                                <Icon name="github" />
                            </Link>
                        </li>
                    </ul>
                </footer>
            )
        }}
    />
)

const query = graphql`
    query {
        site {
            siteMetadata {
                company
                companyUrl
                imprintUrl
                youtube
                email
                twitter
                github
                footer {
                    label
                    items {
                        text
                        url
                        blank
                    }
                }
            }
        }
    }
`
